export default __webpack_public_path__ + "331f9d28d8bb36ccc7fc5a38ab3d54a9.png";